import { render, staticRenderFns } from "./ModuleBuilder.vue?vue&type=template&id=a1808e0e&scoped=true"
import script from "./ModuleBuilder.vue?vue&type=script&lang=js"
export * from "./ModuleBuilder.vue?vue&type=script&lang=js"
import style0 from "./ModuleBuilder.vue?vue&type=style&index=0&id=a1808e0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1808e0e",
  null
  
)

export default component.exports